<!-- <div class="inner-loader" *ngIf="showLoader">
  <mat-progress-spinner class="tp-margin" [color]="color" [mode]="mode">
  </mat-progress-spinner>
</div> -->

<!-- Home list -->
<div class="home-page row" *ngIf="serviceLocationStatus == 'home'">
  <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12"
    *ngFor="let obj of serviceResponseArrayModel.ServiceLists| slice:0:4;">
    <div class="wrapper-list-thumb service-card">
      <div class="room-img-wrapper">
        <a [routerLink]="['/hotel-services',obj.id]">
          <img [src]="obj.ServiceImages[0]" *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
          <ng-template #otherImage>
            <img src="assets/images/No_Image_Available.jpg" />
          </ng-template>
        </a>
      </div>

      <div class="list-thumb-content">
        <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
          <a class="primary-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
        </p>
        <ng-template #otherService>
          <p class="title-info"><a class="primary-text" [routerLink]="['/hotel-services',obj.id]">{{ 'NotAvailable'|translate }}</a></p>
        </ng-template>
        <p class="type-info secondary-text"
          *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department); else otherDepartment">
          <span>{{obj?.Department?.Department[0]?.Value}}</span>
        </p>
        <ng-template #otherDepartment>
          <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
        </ng-template>
        <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
          <span class="badge" [style.color]="obj?.Category?.CategoryColor" style="background-color: transparent;">{{ getCategoryName(obj.Category) }}</span>
        </div>

        <!-- <span>
          <star-rating value="5" checkedcolor="#f8b833" uncheckedcolor="#d0d0d4" size="14px" readonly="false"
            (rate)="onRate($event)" class="star_rating_outer"></star-rating> 9 {{'Reviews'|translate}}
        </span> -->

        <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">
          <ng-container *ngIf="obj.DateTime == '1'">
            <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

              <ng-container *ngIf="service.DaysNames">
                <span *ngFor="let item of service.DaysNames" class="date-from">
                  <ng-container *ngIf="item.Monday">
                    {{'Mon'}}
                  </ng-container>
                  <ng-container *ngIf="item.Tuesday">
                    {{'Tue'}}
                  </ng-container>
                  <ng-container *ngIf="item.Wednesday">
                    {{'Wed'}}
                  </ng-container>
                  <ng-container *ngIf="item.Thursday">
                    {{'Thu'}}
                  </ng-container>
                  <ng-container *ngIf="item.Friday">
                    {{'Fri'}}
                  </ng-container>
                  <ng-container *ngIf="item.Saturday">
                    {{'Sat'}}
                  </ng-container>
                  <ng-container *ngIf="item.Sunday">
                    {{'Sun'}}
                  </ng-container>
                </span>
              </ng-container>

              <span class="time-from">
                <ng-container *ngIf="service.FromTime">
                  {{service.FromTime|timeFormat}}
                </ng-container>
                <ng-container *ngIf="service.ToTime">
                  - {{service.ToTime|timeFormat}}
                </ng-container>
              </span>
            </span>
          </ng-container>
          <ng-container *ngIf="obj.DateTime == '2'">
            <p class="secondary-text date-time-list mb-2" *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
              <span class="date-from">
                <ng-container *ngIf="tour.DateFrom">
                  {{tour.DateFrom|dateFormat}} -
                </ng-container>
                <ng-container *ngIf="tour.DateFrom">
                  {{tour.DateTo|dateFormat}}
                </ng-container>
              </span>
              <span class="time-from">
                <ng-container *ngIf="tour.TimeFrom">
                  {{tour.TimeFrom|timeFormat}}
                </ng-container>
                <ng-container *ngIf="tour.TimeTo">
                  - {{tour.TimeTo|timeFormat}}
                </ng-container>
              </span>

            </p>
          </ng-container>
        </span>

      </div>
    </div>
  </div>
</div>

<!-- //Home list -->

<!-- Home Page Menu Page -->
<div class="home-page" *ngIf="serviceLocationStatus == 'homePageMenu'">
  <div class="row mx-0 "
    *ngIf="!globalService.validateIsEmpty(serviceResponseArrayModel.ServiceLists) && serviceResponseArrayModel.ServiceLists.length else otherServiceLists">
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12  mb-3"
      *ngFor="let obj of serviceResponseArrayModel.ServiceLists">
      <div class="wrapper-list-thumb position-relative wrapper-list-thumb-manage">
        <div class="delete-image"> <i class="material-icons" (click)="deactivateFromHome(obj.id)"
            [appAccessCheck]="'homepage-menu'" [givenButton]="'delete'">delete</i></div>
        <div class="room-img-wrapper">
          <span *ngIf="obj.ServiceImages && obj.ServiceImages.length" class="span-image-wrapper">
            <img [src]="obj.ServiceImages[0]" />
            <ng-template #otherImage>
              <img src="assets/images/No_Image_Available.jpg" />
            </ng-template>
          </span>
          <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

            <ng-container *ngIf="obj.DateTime == '1'">
              <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                <ng-container *ngIf="service.DaysNames">
                  <span *ngFor="let item of service.DaysNames" class="date-from">
                    <ng-container *ngIf="item.Monday">
                      {{'Mon'}}
                    </ng-container>
                    <ng-container *ngIf="item.Tuesday">
                      {{'Tue'}}
                    </ng-container>
                    <ng-container *ngIf="item.Wednesday">
                      {{'Wed'}}
                    </ng-container>
                    <ng-container *ngIf="item.Thursday">
                      {{'Thu'}}
                    </ng-container>
                    <ng-container *ngIf="item.Friday">
                      {{'Fri'}}
                    </ng-container>
                    <ng-container *ngIf="item.Saturday">
                      {{'Sat'}}
                    </ng-container>
                    <ng-container *ngIf="item.Sunday">
                      {{'Sun'}}
                    </ng-container>
                  </span>
                </ng-container>

                <span class="time-from">
                  <ng-container *ngIf="service.FromTime">
                    {{service.FromTime|timeFormat}}
                  </ng-container>
                  <ng-container *ngIf="service.ToTime">
                    - {{service.ToTime|timeFormat}}
                  </ng-container>
                </span>
              </span>
            </ng-container>
            <ng-container *ngIf="obj.DateTime == '2'">
              <p class="secondary-text date-time-list mb-2" *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                <span class="date-from">
                  <ng-container *ngIf="tour.DateFrom">
                    {{tour.DateFrom|dateFormat}} -
                  </ng-container>
                  <ng-container *ngIf="tour.DateFrom">
                    {{tour.DateTo|dateFormat}}
                  </ng-container>
                </span>
                <span class="time-from">
                  <ng-container *ngIf="tour.TimeFrom">
                    {{tour.TimeFrom|timeFormat}}
                  </ng-container>
                  <ng-container *ngIf="tour.TimeTo">
                    - {{tour.TimeTo|timeFormat}}
                  </ng-container>
                </span>

              </p>
            </ng-container>
          </span>
        </div>

        <div class="list-thumb-content">
          <p class="type-info secondary-text"
            *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department); else otherDepartment">
            <span>{{obj?.Department?.Department[0]?.Value}}</span>
          </p>
          <ng-template #otherDepartment>
            <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
          </ng-template>
          <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
            <span 
              class="badge"
              [style.color]="obj?.Category?.CategoryColor"
              style="background-color: transparent;">
    
              {{ getCategoryName(obj.Category) }}
    
            </span>
          </div>
          <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else  otherService">
            <a class="primary-text" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
          </p>
          <ng-template #otherService>
            <p class="title-info"><a class="primary-text">{{
                'NotAvailable'|translate }}</a></p>
          </ng-template>

          <!-- <span>
            <star-rating value="5" checkedcolor="#f8b833" uncheckedcolor="#d0d0d4" size="14px" readonly="false"
              (rate)="onRate($event)" class="star_rating_outer"></star-rating> 9 {{'Reviews'|translate}}
          </span> -->

        </div>
      </div>
    </div>
  </div>
  <ng-template #otherServiceLists>
    <div class="secondary-text">{{'NotAvailable'|translate }}</div>
  </ng-template>
</div>



<!---Home Front View-->
<div class="room-front-view service-guest-dashboard" *ngIf="serviceLocationStatus == 'serviceFrontView'">
  <div class="category-filter-section mb-4" *ngIf="categories && categories.length > 0">
    <div class="category-filter-outer">
      <button type="button" class="category-nav-arrow"
        (click)="scrollCategoryStrip(-1, serviceCatStripGuest)"
        aria-label="Scroll categories left">
        <span aria-hidden="true">&#8249;</span>
      </button>
      <div class="category-filter" #serviceCatStripGuest>
      <button class="filter-btn" [class.active]="selectedCategory === null" (click)="filterByCategory(null)">
        {{'All'|translate}} <span class="count-badge">{{totalServiceCount}}</span>
      </button>
      <button class="filter-btn"
        *ngFor="let cat of categories"
        [class.active]="selectedCategory === cat._id"
        [ngStyle]="selectedCategory === cat._id ? {} : { color: cat.CategoryColor }"
        (click)="filterByCategory(cat._id)">       

        {{ getCategoryName(cat) }}
        <span class="count-badge">{{ cat.Count || 0 }}</span>
      </button>
      </div>
      <button type="button" class="category-nav-arrow"
        (click)="scrollCategoryStrip(1, serviceCatStripGuest)"
        aria-label="Scroll categories right">
        <span aria-hidden="true">&#8250;</span>
      </button>
    </div>
  </div>

  <div class="row">
    <mat-tab-group class="w-100 booking-service-guest" #tabGroup [selectedIndex]="selectedServiceTabIndex" (selectedTabChange)="tabChanged($event)">
      <mat-tab label="{{'Booking Services'|translate}}" class="booking-service-label ">
        <div class="row width-100">
          <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
          <ng-container *ngIf="servicesList?.length">
            <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
              *ngFor="let obj of this.servicesList"> <!--*ngIf="obj.ServiceType != '3'"-->
              <div class="wrapper-list-thumb">
                <div class="room-img-wrapper">
                  <a [routerLink]="['/hotel-services',obj.id]">
                    <img [src]="obj.ServiceImages[0]"
                      *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                    <ng-template #otherImage>
                      <img src="assets/images/No_Image_Available.jpg" />
                    </ng-template>
                  </a>

                  <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                    <ng-container *ngIf="obj.DateTime == '1'">
                      <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                        <ng-container *ngIf="service.DaysNames">
                          <span *ngFor="let item of service.DaysNames" class="date-from">
                            <ng-container *ngIf="item.Monday">
                              {{'Mon'}}
                            </ng-container>
                            <ng-container *ngIf="item.Tuesday">
                              {{'Tue'}}
                            </ng-container>
                            <ng-container *ngIf="item.Wednesday">
                              {{'Wed'}}
                            </ng-container>
                            <ng-container *ngIf="item.Thursday">
                              {{'Thu'}}
                            </ng-container>
                            <ng-container *ngIf="item.Friday">
                              {{'Fri'}}
                            </ng-container>
                            <ng-container *ngIf="item.Saturday">
                              {{'Sat'}}
                            </ng-container>
                            <ng-container *ngIf="item.Sunday">
                              {{'Sun'}}
                            </ng-container>
                          </span>
                        </ng-container>

                        <span class="time-from">
                          <ng-container *ngIf="service.FromTime">
                            {{service.FromTime|timeFormat}}
                          </ng-container>
                          <ng-container *ngIf="service.ToTime">
                            - {{service.ToTime|timeFormat}}
                          </ng-container>
                        </span>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="obj.DateTime == '2'">
                      <p class="secondary-text date-time-list mb-2"
                        *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                        <span class="date-from">
                          <ng-container *ngIf="tour.DateFrom">
                            {{tour.DateFrom|dateFormat}} -
                          </ng-container>
                          <ng-container *ngIf="tour.DateFrom">
                            {{tour.DateTo|dateFormat}}
                          </ng-container>
                        </span>
                        <span class="time-from">
                          <ng-container *ngIf="tour.TimeFrom">
                            {{tour.TimeFrom|timeFormat}}
                          </ng-container>
                          <ng-container *ngIf="tour.TimeTo">
                            - {{tour.TimeTo|timeFormat}}
                          </ng-container>
                        </span>

                      </p>
                    </ng-container>
                  </span>
                </div>

                <div class="list-thumb-content">
                  <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                    <a class="primary-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                  </p>
                  <ng-template #otherService>
                    <p class="title-info"><a class="primary-text" [routerLink]="['/hotel-services',obj.id]">{{
                        'NotAvailable'|translate }}</a></p>
                  </ng-template>
                  <div *ngIf="!obj.InternalService">
                    <p class="type-info secondary-text"
                      *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                      <span>{{obj?.Department?.Department[0]?.Value}}</span>
                    </p>
                    <ng-template #otherDepartment>
                      <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                    </ng-template>
                  </div>
                  <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
                      {{ getCategoryName(obj.Category) }}
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="false">
            <div class="gallery-item-list col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-4"
              *ngFor="let obj of this.servicesList">
              <div class="wrapper-list-thumb">
                <div class="list-thumb-content">
                  <div class="d-flex align-items-center jusitfy-content-start list-view-area-n mb-2">
                    <p class="title-info d-flex align-items-center justify-content-between width100 flex-wrap"
                      *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                      <a class="primary-text full-width-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}
                      </a>
                      <span>
                        <span class="paid-service-tag">Paid</span> <span class="unpaid-service-tag">Free</span>
                      </span>
                    </p>
                    <ng-template #otherService>
                      <p class="title-info  mr-3"><a [routerLink]="['/hotel-services',obj.id]" class="primary-text full-width-text">{{
                          'NotAvailable'|translate }}</a></p>
                    </ng-template>
                    <p class="type-info secondary-text mb-0 mt-2">
                      ( <span
                        *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">{{obj?.Department?.Department[0]?.Value}}</span>
                      <ng-template #otherDepartment>
                        <span>{{ 'NotAvailable'|translate }}</span>
                      </ng-template>
                      <!-- <span>
                    <star-rating value="5" checkedcolor="#f8b833" uncheckedcolor="#d0d0d4" size="14px" readonly="false"
                      (rate)="onRate($event)" class="star_rating_outer"></star-rating> 9 {{'Reviews'|translate}}
                  </span> -->)
                    </p>
                  </div>


                  <!-- <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                <ng-container *ngIf="obj.DateTime == '1'">
                  <span class="secondary-text date-time-list date-time-list-detail mb-2"
                    *ngFor="let service of obj.ServiceAvailability">

                    <ng-container *ngIf="service.DaysNames">
                      <span *ngFor="let item of service.DaysNames" class="date-from">
                        <ng-container *ngIf="item.Monday">
                          {{'Mon'}}
                        </ng-container>
                        <ng-container *ngIf="item.Tuesday">
                          {{'Tue'}}
                        </ng-container>
                        <ng-container *ngIf="item.Wednesday">
                          {{'Wed'}}
                        </ng-container>
                        <ng-container *ngIf="item.Thursday">
                          {{'Thu'}}
                        </ng-container>
                        <ng-container *ngIf="item.Friday">
                          {{'Fri'}}
                        </ng-container>
                        <ng-container *ngIf="item.Saturday">
                          {{'Sat'}}
                        </ng-container>
                        <ng-container *ngIf="item.Sunday">
                          {{'Sun'}}
                        </ng-container>
                      </span>
                    </ng-container>

                    <span class="time-from">
                      <ng-container *ngIf="service.FromTime">
                        {{service.FromTime|timeFormat}} -
                      </ng-container>
                      <ng-container *ngIf="service.ToTime">
                        {{service.ToTime|timeFormat}}
                      </ng-container>
                    </span>
                  </span>
                </ng-container>
                <ng-container *ngIf="obj.DateTime == '2'">
                  <p class="secondary-text date-time-list  date-time-list-detail mb-2"
                    *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                    <span class="date-from">
                      <ng-container *ngIf="tour.DateFrom">
                        {{tour.DateFrom|dateFormat}} -
                      </ng-container>
                      <ng-container *ngIf="tour.DateFrom">
                        {{tour.DateTo|dateFormat}}
                      </ng-container>
                    </span>
                    <span class="time-from">
                      <ng-container *ngIf="tour.TimeFrom">
                        {{tour.TimeFrom|timeFormat}} -
                      </ng-container>
                      <ng-container *ngIf="tour.TimeTo">
                        {{tour.TimeTo|timeFormat}}
                      </ng-container>
                    </span>

                  </p>
                </ng-container>
              </span> -->
                  <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span 
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
    
                      {{ getCategoryName(obj.Category) }}
    
                    </span>
                  </div>

                  <!-- <div class="secondary-text" *ngIf="obj.ServiceDescription && obj.ServiceDescription.length && obj.ServiceDescription[0].Value.length > 60">
              ---
          </div> -->
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="{{'Maintainance / Unpaid Service'|translate}}" class="booking-service-label ">
        <div class="row width-100">
          <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
          <ng-container *ngIf="servicesList?.length">
            <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
              *ngFor="let obj of this.servicesList"> <!--*ngIf="obj.ServiceType != '3'"-->
              <div class="wrapper-list-thumb">
                <div class="room-img-wrapper">
                  <a [routerLink]="['/hotel-services',obj.id]">
                    <img [src]="obj.ServiceImages[0]"
                      *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                    <ng-template #otherImage>
                      <img src="assets/images/No_Image_Available.jpg" />
                    </ng-template>
                  </a>

                  <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                    <ng-container *ngIf="obj.DateTime == '1'">
                      <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                        <ng-container *ngIf="service.DaysNames">
                          <span *ngFor="let item of service.DaysNames" class="date-from">
                            <ng-container *ngIf="item.Monday">
                              {{'Mon'}}
                            </ng-container>
                            <ng-container *ngIf="item.Tuesday">
                              {{'Tue'}}
                            </ng-container>
                            <ng-container *ngIf="item.Wednesday">
                              {{'Wed'}}
                            </ng-container>
                            <ng-container *ngIf="item.Thursday">
                              {{'Thu'}}
                            </ng-container>
                            <ng-container *ngIf="item.Friday">
                              {{'Fri'}}
                            </ng-container>
                            <ng-container *ngIf="item.Saturday">
                              {{'Sat'}}
                            </ng-container>
                            <ng-container *ngIf="item.Sunday">
                              {{'Sun'}}
                            </ng-container>
                          </span>
                        </ng-container>

                        <span class="time-from">
                          <ng-container *ngIf="service.FromTime">
                            {{service.FromTime|timeFormat}}
                          </ng-container>
                          <ng-container *ngIf="service.ToTime">
                            - {{service.ToTime|timeFormat}}
                          </ng-container>
                        </span>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="obj.DateTime == '2'">
                      <p class="secondary-text date-time-list mb-2"
                        *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                        <span class="date-from">
                          <ng-container *ngIf="tour.DateFrom">
                            {{tour.DateFrom|dateFormat}} -
                          </ng-container>
                          <ng-container *ngIf="tour.DateFrom">
                            {{tour.DateTo|dateFormat}}
                          </ng-container>
                        </span>
                        <span class="time-from">
                          <ng-container *ngIf="tour.TimeFrom">
                            {{tour.TimeFrom|timeFormat}}
                          </ng-container>
                          <ng-container *ngIf="tour.TimeTo">
                            - {{tour.TimeTo|timeFormat}}
                          </ng-container>
                        </span>

                      </p>
                    </ng-container>
                  </span>
                </div>

                <div class="list-thumb-content">
                  <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                    <a class="primary-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                  </p>
                  <ng-template #otherService>
                    <p class="title-info"><a class="primary-text" [routerLink]="['/hotel-services',obj.id]">{{
                        'NotAvailable'|translate }}</a></p>
                  </ng-template>
                  <div *ngIf="!obj.InternalService">
                    <p class="type-info secondary-text"
                      *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                      <span>{{obj?.Department?.Department[0]?.Value}}</span>
                    </p>
                    <ng-template #otherDepartment>
                      <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                    </ng-template>
                  </div>
                  <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
                      {{ getCategoryName(obj.Category) }}
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="false">
            <div class="gallery-item-list col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-4"
              *ngFor="let obj of this.servicesList">
              <div class="wrapper-list-thumb">
                <div class="list-thumb-content">
                  <div class="d-flex align-items-center jusitfy-content-start list-view-area-n mb-2">
                    <p class="title-info d-flex align-items-center justify-content-between width100 flex-wrap"
                      *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                      <a class="primary-text full-width-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}
                      </a>
                      <span class="paid-service-tag">Paid</span> <span class="unpaid-service-tag">Free</span>
                    </p>
                    <ng-template #otherService>
                      <p class="title-info  mr-3"><a [routerLink]="['/hotel-services',obj.id]" class="primary-text full-width-text">{{
                          'NotAvailable'|translate }}</a></p>
                    </ng-template>
                    <p class="type-info secondary-text mb-0 mt-2">
                      ( <span
                        *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">{{obj?.Department?.Department[0]?.Value}}</span>
                      <ng-template #otherDepartment>
                        <span>{{ 'NotAvailable'|translate }}</span>
                      </ng-template>
                      <!-- <span>
                    <star-rating value="5" checkedcolor="#f8b833" uncheckedcolor="#d0d0d4" size="14px" readonly="false"
                      (rate)="onRate($event)" class="star_rating_outer"></star-rating> 9 {{'Reviews'|translate}}
                  </span> -->)
                    </p>
                  </div>


                  <!-- <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                <ng-container *ngIf="obj.DateTime == '1'">
                  <span class="secondary-text date-time-list date-time-list-detail mb-2"
                    *ngFor="let service of obj.ServiceAvailability">

                    <ng-container *ngIf="service.DaysNames">
                      <span *ngFor="let item of service.DaysNames" class="date-from">
                        <ng-container *ngIf="item.Monday">
                          {{'Mon'}}
                        </ng-container>
                        <ng-container *ngIf="item.Tuesday">
                          {{'Tue'}}
                        </ng-container>
                        <ng-container *ngIf="item.Wednesday">
                          {{'Wed'}}
                        </ng-container>
                        <ng-container *ngIf="item.Thursday">
                          {{'Thu'}}
                        </ng-container>
                        <ng-container *ngIf="item.Friday">
                          {{'Fri'}}
                        </ng-container>
                        <ng-container *ngIf="item.Saturday">
                          {{'Sat'}}
                        </ng-container>
                        <ng-container *ngIf="item.Sunday">
                          {{'Sun'}}
                        </ng-container>
                      </span>
                    </ng-container>

                    <span class="time-from">
                      <ng-container *ngIf="service.FromTime">
                        {{service.FromTime|timeFormat}} -
                      </ng-container>
                      <ng-container *ngIf="service.ToTime">
                        {{service.ToTime|timeFormat}}
                      </ng-container>
                    </span>
                  </span>
                </ng-container>
                <ng-container *ngIf="obj.DateTime == '2'">
                  <p class="secondary-text date-time-list  date-time-list-detail mb-2"
                    *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                    <span class="date-from">
                      <ng-container *ngIf="tour.DateFrom">
                        {{tour.DateFrom|dateFormat}} -
                      </ng-container>
                      <ng-container *ngIf="tour.DateFrom">
                        {{tour.DateTo|dateFormat}}
                      </ng-container>
                    </span>
                    <span class="time-from">
                      <ng-container *ngIf="tour.TimeFrom">
                        {{tour.TimeFrom|timeFormat}} -
                      </ng-container>
                      <ng-container *ngIf="tour.TimeTo">
                        {{tour.TimeTo|timeFormat}}
                      </ng-container>
                    </span>

                  </p>
                </ng-container>
              </span> -->
                  <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span 
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
    
                      {{ getCategoryName(obj.Category) }}
    
                    </span>
                  </div>

                  <!-- <div class="secondary-text" *ngIf="obj.ServiceDescription && obj.ServiceDescription.length && obj.ServiceDescription[0].Value.length > 60">
              ---
          </div> -->
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="{{'Information only'|translate}}" class="booking-service-label ">
        <div class="row width-100">
          <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
          <ng-container *ngIf="servicesList?.length">
            <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
              *ngFor="let obj of this.servicesList"> <!--*ngIf="obj.ServiceType != '3'"-->
              <div class="wrapper-list-thumb">
                <div class="room-img-wrapper">
                  <a [routerLink]="['/hotel-services',obj.id]">
                    <img [src]="obj.ServiceImages[0]"
                      *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                    <ng-template #otherImage>
                      <img src="assets/images/No_Image_Available.jpg" />
                    </ng-template>
                  </a>

                  <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                    <ng-container *ngIf="obj.DateTime == '1'">
                      <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                        <ng-container *ngIf="service.DaysNames">
                          <span *ngFor="let item of service.DaysNames" class="date-from">
                            <ng-container *ngIf="item.Monday">
                              {{'Mon'}}
                            </ng-container>
                            <ng-container *ngIf="item.Tuesday">
                              {{'Tue'}}
                            </ng-container>
                            <ng-container *ngIf="item.Wednesday">
                              {{'Wed'}}
                            </ng-container>
                            <ng-container *ngIf="item.Thursday">
                              {{'Thu'}}
                            </ng-container>
                            <ng-container *ngIf="item.Friday">
                              {{'Fri'}}
                            </ng-container>
                            <ng-container *ngIf="item.Saturday">
                              {{'Sat'}}
                            </ng-container>
                            <ng-container *ngIf="item.Sunday">
                              {{'Sun'}}
                            </ng-container>
                          </span>
                        </ng-container>

                        <span class="time-from">
                          <ng-container *ngIf="service.FromTime">
                            {{service.FromTime|timeFormat}}
                          </ng-container>
                          <ng-container *ngIf="service.ToTime">
                            - {{service.ToTime|timeFormat}}
                          </ng-container>
                        </span>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="obj.DateTime == '2'">
                      <p class="secondary-text date-time-list mb-2"
                        *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                        <span class="date-from">
                          <ng-container *ngIf="tour.DateFrom">
                            {{tour.DateFrom|dateFormat}} -
                          </ng-container>
                          <ng-container *ngIf="tour.DateFrom">
                            {{tour.DateTo|dateFormat}}
                          </ng-container>
                        </span>
                        <span class="time-from">
                          <ng-container *ngIf="tour.TimeFrom">
                            {{tour.TimeFrom|timeFormat}}
                          </ng-container>
                          <ng-container *ngIf="tour.TimeTo">
                            - {{tour.TimeTo|timeFormat}}
                          </ng-container>
                        </span>

                      </p>
                    </ng-container>
                  </span>
                </div>

                <div class="list-thumb-content">
                  <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                    <a class="primary-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                  </p>
                  <ng-template #otherService>
                    <p class="title-info"><a class="primary-text" [routerLink]="['/hotel-services',obj.id]">{{
                        'NotAvailable'|translate }}</a></p>
                  </ng-template>
                  <div *ngIf="!obj.InternalService">
                    <p class="type-info secondary-text"
                      *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                      <span>{{obj?.Department?.Department[0]?.Value}}</span>
                    </p>
                    <ng-template #otherDepartment>
                      <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                    </ng-template>
                  </div>
                  <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
                      {{ getCategoryName(obj.Category) }}
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="false">
            <div class="gallery-item-list col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-4"
              *ngFor="let obj of this.servicesList">
              <div class="wrapper-list-thumb">
                <div class="list-thumb-content">
                  <div class="d-flex align-items-center jusitfy-content-start list-view-area-n mb-2">
                    <p class="title-info d-flex align-items-center justify-content-between width100 flex-wrap"
                      *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                      <a class="primary-text full-width-text" [routerLink]="['/hotel-services',obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}
                      </a>
                      <span class="paid-service-tag">Paid</span> <span class="unpaid-service-tag">Free</span>
                    </p>
                    <ng-template #otherService>
                      <p class="title-info  mr-3"><a [routerLink]="['/hotel-services',obj.id]" class="primary-text full-width-text">{{
                          'NotAvailable'|translate }}</a></p>
                    </ng-template>
                    <p class="type-info secondary-text mb-0 mt-2">
                      ( <span
                        *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">{{obj?.Department?.Department[0]?.Value}}</span>
                      <ng-template #otherDepartment>
                        <span>{{ 'NotAvailable'|translate }}</span>
                      </ng-template>
                      <!-- <span>
                    <star-rating value="5" checkedcolor="#f8b833" uncheckedcolor="#d0d0d4" size="14px" readonly="false"
                      (rate)="onRate($event)" class="star_rating_outer"></star-rating> 9 {{'Reviews'|translate}}
                  </span> -->)
                    </p>
                  </div>


                  <!-- <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                <ng-container *ngIf="obj.DateTime == '1'">
                  <span class="secondary-text date-time-list date-time-list-detail mb-2"
                    *ngFor="let service of obj.ServiceAvailability">

                    <ng-container *ngIf="service.DaysNames">
                      <span *ngFor="let item of service.DaysNames" class="date-from">
                        <ng-container *ngIf="item.Monday">
                          {{'Mon'}}
                        </ng-container>
                        <ng-container *ngIf="item.Tuesday">
                          {{'Tue'}}
                        </ng-container>
                        <ng-container *ngIf="item.Wednesday">
                          {{'Wed'}}
                        </ng-container>
                        <ng-container *ngIf="item.Thursday">
                          {{'Thu'}}
                        </ng-container>
                        <ng-container *ngIf="item.Friday">
                          {{'Fri'}}
                        </ng-container>
                        <ng-container *ngIf="item.Saturday">
                          {{'Sat'}}
                        </ng-container>
                        <ng-container *ngIf="item.Sunday">
                          {{'Sun'}}
                        </ng-container>
                      </span>
                    </ng-container>

                    <span class="time-from">
                      <ng-container *ngIf="service.FromTime">
                        {{service.FromTime|timeFormat}} -
                      </ng-container>
                      <ng-container *ngIf="service.ToTime">
                        {{service.ToTime|timeFormat}}
                      </ng-container>
                    </span>
                  </span>
                </ng-container>
                <ng-container *ngIf="obj.DateTime == '2'">
                  <p class="secondary-text date-time-list  date-time-list-detail mb-2"
                    *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                    <span class="date-from">
                      <ng-container *ngIf="tour.DateFrom">
                        {{tour.DateFrom|dateFormat}} -
                      </ng-container>
                      <ng-container *ngIf="tour.DateFrom">
                        {{tour.DateTo|dateFormat}}
                      </ng-container>
                    </span>
                    <span class="time-from">
                      <ng-container *ngIf="tour.TimeFrom">
                        {{tour.TimeFrom|timeFormat}} -
                      </ng-container>
                      <ng-container *ngIf="tour.TimeTo">
                        {{tour.TimeTo|timeFormat}}
                      </ng-container>
                    </span>

                  </p>
                </ng-container>
              </span> -->
                  <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span 
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
    
                      {{ getCategoryName(obj.Category) }}
    
                    </span>
                  </div>

                  <!-- <div class="secondary-text" *ngIf="obj.ServiceDescription && obj.ServiceDescription.length && obj.ServiceDescription[0].Value.length > 60">
              ---
          </div> -->
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-tab>

    </mat-tab-group>
    <div class="pagination" *ngIf="serviceResponseArrayModel.ServiceLists">
      <span *ngIf="serviceResponseArrayModel.ServiceLists.length">
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
        </mat-paginator>
      </span>
    </div>


  </div>
</div>


<div class="room-front-view service-admin-dashboard" *ngIf="serviceLocationStatus == 'serviceAdminView'">
  <div class="category-filter-section mb-4" *ngIf="categories && categories.length > 0">
    <div class="category-filter-outer">
      <button type="button" class="category-nav-arrow"
        (click)="scrollCategoryStrip(-1, serviceCatStripAdmin)"
        aria-label="Scroll categories left">
        <span aria-hidden="true">&#8249;</span>
      </button>
      <div class="category-filter" #serviceCatStripAdmin>
      <button class="filter-btn" [class.active]="selectedCategory === null" (click)="filterByCategory(null)">
        {{'All'|translate}} <span class="count-badge">{{totalServiceCount}}</span>
      </button>
      <button class="filter-btn"
        *ngFor="let cat of categories"
        [class.active]="selectedCategory === cat._id"
        [ngStyle]="selectedCategory === cat._id ? {} : { color: cat.CategoryColor }"
        (click)="filterByCategory(cat._id)">
        {{ getCategoryName(cat) }}
        <span class="count-badge">{{ cat.Count || 0 }}</span>
      </button>
      </div>
      <button type="button" class="category-nav-arrow"
        (click)="scrollCategoryStrip(1, serviceCatStripAdmin)"
        aria-label="Scroll categories right">
        <span aria-hidden="true">&#8250;</span>
      </button>
    </div>
  </div>
  <div class="row">
    <mat-tab-group class="w-100 booking-service-guest" #tabGroup [selectedIndex]="adminMatTabSelectedIndex" (selectedTabChange)="tabChanged($event)">
      <mat-tab *ngIf="isAdminServiceTabVisible('all')" label="{{'All'|translate}}" class="booking-service-label ">
        <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
        <ng-container *ngIf="servicesList?.length">
          <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let obj of this.servicesList">
            <div class="wrapper-list-thumb">
              <div class="room-img-wrapper">
                <a [routerLink]="[userRoleRoute,obj.id]">
                  <img [src]="obj.ServiceImages[0]"
                    *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImageAllSvc" />
                  <ng-template #otherImageAllSvc>
                    <img src="assets/images/No_Image_Available.jpg" />
                  </ng-template>
                </a>

                <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                  <ng-container *ngIf="obj.DateTime == '1'">
                    <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                      <ng-container *ngIf="service.DaysNames">
                        <span *ngFor="let item of service.DaysNames" class="date-from">
                          <ng-container *ngIf="item.Monday">
                            {{'Mon'}}
                          </ng-container>
                          <ng-container *ngIf="item.Tuesday">
                            {{'Tue'}}
                          </ng-container>
                          <ng-container *ngIf="item.Wednesday">
                            {{'Wed'}}
                          </ng-container>
                          <ng-container *ngIf="item.Thursday">
                            {{'Thu'}}
                          </ng-container>
                          <ng-container *ngIf="item.Friday">
                            {{'Fri'}}
                          </ng-container>
                          <ng-container *ngIf="item.Saturday">
                            {{'Sat'}}
                          </ng-container>
                          <ng-container *ngIf="item.Sunday">
                            {{'Sun'}}
                          </ng-container>
                        </span>
                      </ng-container>

                      <span class="time-from">
                        <ng-container *ngIf="service.FromTime">
                          {{service.FromTime|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="service.ToTime">
                          - {{service.ToTime|timeFormat}}
                        </ng-container>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="obj.DateTime == '2'">
                    <p class="secondary-text date-time-list mb-2"
                      *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                      <span class="date-from">
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateFrom|dateFormat}} -
                        </ng-container>
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateTo|dateFormat}}
                        </ng-container>
                      </span>
                      <span class="time-from">
                        <ng-container *ngIf="tour.TimeFrom">
                          {{tour.TimeFrom|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="tour.TimeTo">
                          - {{tour.TimeTo|timeFormat}}
                        </ng-container>
                      </span>

                    </p>
                  </ng-container>
                </span>
              </div>

              <div class="list-thumb-content">
                <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherServiceAllSvc">
                  <a class="primary-text" [routerLink]="[userRoleRoute, obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                </p>
                <ng-template #otherServiceAllSvc>
                  <p class="title-info"><a class="primary-text" [routerLink]="[userRoleRoute,obj.id]">{{
                      'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div *ngIf="!obj.InternalService">
                  <p class="type-info secondary-text"
                    *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartmentAllSvc">
                    <span>{{obj?.Department?.Department[0]?.Value}}</span>
                  </p>
                  <ng-template #otherDepartmentAllSvc>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                  </ng-template>
                </div>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                  <span 
                    class="badge"
                    [style.color]="obj?.Category?.CategoryColor"
                    style="background-color: transparent;">
    
                    {{ getCategoryName(obj.Category) }}
    
                  </span>
                </div>


              </div>

            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab *ngIf="isAdminServiceTabVisible('booking')" label="Booking Services" class="booking-service-label ">
        <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
        <ng-container *ngIf="servicesList?.length">
          <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let obj of this.servicesList"> <!--*ngIf="obj.ServiceType != '3'"-->
            <div class="wrapper-list-thumb">
              <div class="room-img-wrapper">
                <a [routerLink]="[userRoleRoute,obj.id]">
                  <img [src]="obj.ServiceImages[0]"
                    *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                  <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                  </ng-template>
                </a>

                <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                  <ng-container *ngIf="obj.DateTime == '1'">
                    <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                      <ng-container *ngIf="service.DaysNames">
                        <span *ngFor="let item of service.DaysNames" class="date-from">
                          <ng-container *ngIf="item.Monday">
                            {{'Mon'}}
                          </ng-container>
                          <ng-container *ngIf="item.Tuesday">
                            {{'Tue'}}
                          </ng-container>
                          <ng-container *ngIf="item.Wednesday">
                            {{'Wed'}}
                          </ng-container>
                          <ng-container *ngIf="item.Thursday">
                            {{'Thu'}}
                          </ng-container>
                          <ng-container *ngIf="item.Friday">
                            {{'Fri'}}
                          </ng-container>
                          <ng-container *ngIf="item.Saturday">
                            {{'Sat'}}
                          </ng-container>
                          <ng-container *ngIf="item.Sunday">
                            {{'Sun'}}
                          </ng-container>
                        </span>
                      </ng-container>

                      <span class="time-from">
                        <ng-container *ngIf="service.FromTime">
                          {{service.FromTime|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="service.ToTime">
                          - {{service.ToTime|timeFormat}}
                        </ng-container>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="obj.DateTime == '2'">
                    <p class="secondary-text date-time-list mb-2"
                      *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                      <span class="date-from">
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateFrom|dateFormat}} -
                        </ng-container>
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateTo|dateFormat}}
                        </ng-container>
                      </span>
                      <span class="time-from">
                        <ng-container *ngIf="tour.TimeFrom">
                          {{tour.TimeFrom|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="tour.TimeTo">
                          - {{tour.TimeTo|timeFormat}}
                        </ng-container>
                      </span>

                    </p>
                  </ng-container>
                </span>
              </div>

              <div class="list-thumb-content">
                <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                  <a class="primary-text" [routerLink]="[userRoleRoute, obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                </p>
                <ng-template #otherService>
                  <p class="title-info"><a class="primary-text" [routerLink]="[userRoleRoute,obj.id]">{{
                      'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div *ngIf="!obj.InternalService">
                  <p class="type-info secondary-text"
                    *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                    <span>{{obj?.Department?.Department[0]?.Value}}</span>
                  </p>
                  <ng-template #otherDepartment>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                  </ng-template>
                </div>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                  <span 
                    class="badge"
                    [style.color]="obj?.Category?.CategoryColor"
                    style="background-color: transparent;">
    
                    {{ getCategoryName(obj.Category) }}
    
                  </span>
                </div>


              </div>

            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab *ngIf="isAdminServiceTabVisible('maintenance')" label="Maintenance / Unpaid Services" class="booking-service-label ">
        <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
        <ng-container *ngIf="servicesList?.length">
          <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let obj of this.servicesList"> <!--*ngIf="obj.ServiceType != '3'"-->
            <div class="wrapper-list-thumb">
              <div class="room-img-wrapper">
                <a [routerLink]="[userRoleRoute, obj.id]">
                  <img [src]="obj.ServiceImages[0]"
                    *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                  <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                  </ng-template>
                </a>


                <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                  <ng-container *ngIf="obj.DateTime == '1'">
                    <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                      <ng-container *ngIf="service.DaysNames">
                        <span *ngFor="let item of service.DaysNames" class="date-from">
                          <ng-container *ngIf="item.Monday">
                            {{'Mon'}}
                          </ng-container>
                          <ng-container *ngIf="item.Tuesday">
                            {{'Tue'}}
                          </ng-container>
                          <ng-container *ngIf="item.Wednesday">
                            {{'Wed'}}
                          </ng-container>
                          <ng-container *ngIf="item.Thursday">
                            {{'Thu'}}
                          </ng-container>
                          <ng-container *ngIf="item.Friday">
                            {{'Fri'}}
                          </ng-container>
                          <ng-container *ngIf="item.Saturday">
                            {{'Sat'}}
                          </ng-container>
                          <ng-container *ngIf="item.Sunday">
                            {{'Sun'}}
                          </ng-container>
                        </span>
                      </ng-container>

                      <span class="time-from">
                        <ng-container *ngIf="service.FromTime">
                          {{service.FromTime|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="service.ToTime">
                          - {{service.ToTime|timeFormat}}
                        </ng-container>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="obj.DateTime == '2'">
                    <p class="secondary-text date-time-list mb-2"
                      *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                      <span class="date-from">
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateFrom|dateFormat}} -
                        </ng-container>
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateTo|dateFormat}}
                        </ng-container>
                      </span>
                      <span class="time-from">
                        <ng-container *ngIf="tour.TimeFrom">
                          {{tour.TimeFrom|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="tour.TimeTo">
                          - {{tour.TimeTo|timeFormat}}
                        </ng-container>
                      </span>

                    </p>
                  </ng-container>
                </span>
              </div>

              <div class="list-thumb-content">
                <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                  <a class="primary-text" [routerLink]="[userRoleRoute, obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                </p>
                <ng-template #otherService>
                  <p class="title-info"><a class="primary-text" [routerLink]="[userRoleRoute, obj.id]">{{
                      'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div *ngIf="!obj.InternalService">
                  <p class="type-info secondary-text"
                    *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                    <span>{{obj?.Department?.Department[0]?.Value}}</span>
                  </p>
                  <ng-template #otherDepartment>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                  </ng-template>
                </div>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                  <span 
                    class="badge"
                    [style.color]="obj?.Category?.CategoryColor"
                    style="background-color: transparent;">
    
                    {{ getCategoryName(obj.Category) }}
    
                  </span>
                </div>


              </div>

            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab *ngIf="isAdminServiceTabVisible('internal')" label="Internal Services">
        <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
        <ng-container *ngIf="servicesList?.length">
          <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let obj of this.servicesList"> <!--*ngIf="obj.ServiceType != '3'"-->
            <div class="wrapper-list-thumb">
              <div class="room-img-wrapper">
                <a [routerLink]="[userRoleRoute, obj.id]">
                  <img [src]="obj.ServiceImages[0]"
                    *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                  <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                  </ng-template>
                </a>

                <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                  <ng-container *ngIf="obj.DateTime == '1'">
                    <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                      <ng-container *ngIf="service.DaysNames">
                        <span *ngFor="let item of service.DaysNames" class="date-from">
                          <ng-container *ngIf="item.Monday">
                            {{'Mon'}}
                          </ng-container>
                          <ng-container *ngIf="item.Tuesday">
                            {{'Tue'}}
                          </ng-container>
                          <ng-container *ngIf="item.Wednesday">
                            {{'Wed'}}
                          </ng-container>
                          <ng-container *ngIf="item.Thursday">
                            {{'Thu'}}
                          </ng-container>
                          <ng-container *ngIf="item.Friday">
                            {{'Fri'}}
                          </ng-container>
                          <ng-container *ngIf="item.Saturday">
                            {{'Sat'}}
                          </ng-container>
                          <ng-container *ngIf="item.Sunday">
                            {{'Sun'}}
                          </ng-container>
                        </span>
                      </ng-container>

                      <span class="time-from">
                        <ng-container *ngIf="service.FromTime">
                          {{service.FromTime|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="service.ToTime">
                          - {{service.ToTime|timeFormat}}
                        </ng-container>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="obj.DateTime == '2'">
                    <p class="secondary-text date-time-list mb-2"
                      *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                      <span class="date-from">
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateFrom|dateFormat}} -
                        </ng-container>
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateTo|dateFormat}}
                        </ng-container>
                      </span>
                      <span class="time-from">
                        <ng-container *ngIf="tour.TimeFrom">
                          {{tour.TimeFrom|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="tour.TimeTo">
                          - {{tour.TimeTo|timeFormat}}
                        </ng-container>
                      </span>

                    </p>
                  </ng-container>
                </span>
              </div>

              <div class="list-thumb-content">
                <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                  <a class="primary-text" [routerLink]="[userRoleRoute, obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                </p>
                <ng-template #otherService>
                  <p class="title-info"><a class="primary-text" [routerLink]="[userRoleRoute, obj.id]">{{
                      'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div *ngIf="!obj.InternalService">
                  <p class="type-info secondary-text"
                    *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                    <span>{{obj?.Department?.Department[0]?.Value}}</span>
                  </p>
                  <ng-template #otherDepartment>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                  </ng-template>
                </div>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                  <span class="badge" [style.color]="obj?.Category?.CategoryColor" style="background-color: transparent;">{{ getCategoryName(obj.Category) }}</span>
                </div>
              </div>

            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab *ngIf="isAdminServiceTabVisible('hygiene')" label="Hygiene Services">
        <div class="secondary-text p-3" *ngIf="!servicesList?.length">{{ 'NotAvailable'|translate }}</div>
        <ng-container *ngIf="servicesList?.length">
          <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4" *ngFor="let obj of this.servicesList">
            <div class="wrapper-list-thumb">
              <div class="room-img-wrapper">
                <a [routerLink]="[userRoleRoute, obj.id]">
                  <img [src]="obj.ServiceImages[0]" *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                  <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                  </ng-template>
                </a>

                <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">
                  <ng-container *ngIf="obj.DateTime == '1'">
                    <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                      <ng-container *ngIf="service.DaysNames">
                        <span *ngFor="let item of service.DaysNames" class="date-from">
                          <ng-container *ngIf="item.Monday">
                            {{'Mon'}}
                          </ng-container>
                          <ng-container *ngIf="item.Tuesday">
                            {{'Tue'}}
                          </ng-container>
                          <ng-container *ngIf="item.Wednesday">
                            {{'Wed'}}
                          </ng-container>
                          <ng-container *ngIf="item.Thursday">
                            {{'Thu'}}
                          </ng-container>
                          <ng-container *ngIf="item.Friday">
                            {{'Fri'}}
                          </ng-container>
                          <ng-container *ngIf="item.Saturday">
                            {{'Sat'}}
                          </ng-container>
                          <ng-container *ngIf="item.Sunday">
                            {{'Sun'}}
                          </ng-container>
                        </span>
                      </ng-container>

                      <span class="time-from">
                        <ng-container *ngIf="service.FromTime">
                          {{service.FromTime|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="service.ToTime">
                          - {{service.ToTime|timeFormat}}
                        </ng-container>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="obj.DateTime == '2'">
                    <p class="secondary-text date-time-list mb-2" *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                      <span class="date-from">
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateFrom|dateFormat}} -
                        </ng-container>
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateTo|dateFormat}}
                        </ng-container>
                      </span>
                      <span class="time-from">
                        <ng-container *ngIf="tour.TimeFrom">
                          {{tour.TimeFrom|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="tour.TimeTo">
                          - {{tour.TimeTo|timeFormat}}
                        </ng-container>
                      </span>

                    </p>
                  </ng-container>
                </span>
              </div>

              <div class="list-thumb-content">
                <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                  <a class="primary-text" [routerLink]="[userRoleRoute, obj.id]" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                </p>
                <ng-template #otherService>
                  <p class="title-info"><a class="primary-text" [routerLink]="[userRoleRoute, obj.id]">{{
                      'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div *ngIf="!obj.InternalService">
                  <p class="type-info secondary-text"
                    *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                    <span>{{obj?.Department?.Department[0]?.Value}}</span>
                  </p>
                  <ng-template #otherDepartment>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                  </ng-template>
                </div>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                  <span class="badge" [style.color]="obj?.Category?.CategoryColor" style="background-color: transparent;">{{ getCategoryName(obj.Category) }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
    <div class="pagination" *ngIf="serviceResponseArrayModel.ServiceLists">
      <span *ngIf="serviceResponseArrayModel.ServiceLists.length">
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
        </mat-paginator>
      </span>
    </div>
  </div>
</div>


<!---Restaurant Manage Page-->
<div class="room-manage-page row" *ngIf="serviceLocationStatus == 'serviceManagePage'">
  <div class="content-section-outer w-100">
    <div class="content-wrapper">
      <div class="main-content-wrapper row">
        <!-- Home list -->
        <div class="home-page row mx-0  w-100"
          *ngIf="!globalService.validateIsEmpty(serviceResponseArrayModel.ServiceLists)">
          <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12  mb-3"
            *ngFor="let obj of serviceResponseArrayModel.ServiceLists">
            <div class="wrapper-list-thumb position-relative">
              <div class="room-img-wrapper">

                <img [src]="obj.ServiceImages[0]"
                  *ngIf="obj.ServiceImages && obj.ServiceImages.length;else otherImage" />
                <ng-template #otherImage>
                  <img src="assets/images/No_Image_Available.jpg" />
                </ng-template>

                <span *ngIf="!globalService.validateIsEmpty(obj.ServiceAvailability)">

                  <ng-container *ngIf="obj.DateTime == '1'">
                    <span class="secondary-text date-time-list mb-2" *ngFor="let service of obj.ServiceAvailability">

                      <ng-container *ngIf="service.DaysNames">
                        <span *ngFor="let item of service.DaysNames" class="date-from">
                          <ng-container *ngIf="item.Monday">
                            {{'Mon'}}
                          </ng-container>
                          <ng-container *ngIf="item.Tuesday">
                            {{'Tue'}}
                          </ng-container>
                          <ng-container *ngIf="item.Wednesday">
                            {{'Wed'}}
                          </ng-container>
                          <ng-container *ngIf="item.Thursday">
                            {{'Thu'}}
                          </ng-container>
                          <ng-container *ngIf="item.Friday">
                            {{'Fri'}}
                          </ng-container>
                          <ng-container *ngIf="item.Saturday">
                            {{'Sat'}}
                          </ng-container>
                          <ng-container *ngIf="item.Sunday">
                            {{'Sun'}}
                          </ng-container>
                        </span>
                      </ng-container>

                      <span class="time-from">
                        <ng-container *ngIf="service.FromTime">
                          {{service.FromTime|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="service.ToTime">
                          - {{service.ToTime|timeFormat}}
                        </ng-container>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="obj.DateTime == '2'">
                    <p class="secondary-text date-time-list mb-2"
                      *ngFor="let tour of obj.ServiceAvailability| slice:0:1">
                      <span class="date-from">
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateFrom|dateFormat}} -
                        </ng-container>
                        <ng-container *ngIf="tour.DateFrom">
                          {{tour.DateTo|dateFormat}}
                        </ng-container>
                      </span>
                      <span class="time-from">
                        <ng-container *ngIf="tour.TimeFrom">
                          {{tour.TimeFrom|timeFormat}}
                        </ng-container>
                        <ng-container *ngIf="tour.TimeTo">
                          - {{tour.TimeTo|timeFormat}}
                        </ng-container>
                      </span>

                    </p>
                  </ng-container>
                </span>
              </div>
              <span class="restock-warning nunito position-absolute"
                *ngIf="thresholdCheck(obj.id)">{{'SoonOutofStock'|translate}}</span>

              <div class="list-thumb-content">
                <div class="d-flex justify-between slide-toggle-wrapper">
                  <p class="title-info" *ngIf="!globalService.validateIsEmpty(obj.ServiceName);else otherService">
                    <a class="primary-text" [matTooltip]="obj.ServiceName[0].Value">{{obj.ServiceName[0].Value}}</a>
                  </p>
                  <mat-slide-toggle class="manage-dept-toggle" [checked]="obj.IsActive"
                    (change)="onToggleChange($event,obj.id,obj?.ServiceName[0]?.Value)"
                    [appAccessCheck]="'services'" [givenButton]="'edit'">
                  </mat-slide-toggle>
                </div>
                <ng-template #otherService>
                  <p class="title-info"><a class="primary-text">{{
                      'NotAvailable'|translate }}</a></p>
                </ng-template>
                <p class="type-info secondary-text"
                  *ngIf="!globalService.validateIsEmpty(obj?.Department?.Department);else otherDepartment">
                  <span>{{obj?.Department?.Department[0]?.Value}}</span>
                </p>

                <ng-template #otherDepartment>
                  <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                  <span 
                    class="badge"
                    [style.color]="obj?.Category?.CategoryColor"
                    style="background-color: transparent;">
    
                    {{ getCategoryName(obj.Category) }}
    
                  </span>
                </div>
                <!-- <span>
                  <star-rating value="5" checkedcolor="#f8b833" uncheckedcolor="#d0d0d4" size="14px" readonly="false"
                    class="star_rating_outer"></star-rating> 9 {{'Reviews'|translate}}
                </span> -->
              </div>
              <div class="button-section">
                <button type="button" class="btn btn-primary" (click)="detail(obj.id)" [appAccessCheck]="'services'"
                  [givenButton]="'view'">
                  <i class="material-icons">remove_red_eye</i> {{'ViewDetail'|translate}}
                </button>
                <button class="btn btn-secondary" type="type" (click)="edit(obj.id)" [appAccessCheck]="'services'"
                  [givenButton]="'edit'">
                  <i class="material-icons">create</i> {{'Edit'|translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="pagination" *ngIf="serviceResponseArrayModel.ServiceLists">
          <span *ngIf="serviceResponseArrayModel.ServiceLists.length">
            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
              (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
            </mat-paginator>
          </span>
        </div> -->
      </div>
    </div>
  </div>

  <!-- <div class="pagination" *ngIf="resturantResponseArrayModel.ResturantLists">
        <span *ngIf="resturantResponseArrayModel.ResturantLists.length">
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
      </mat-paginator>
    </span>
    </div> -->

  <div class="pagination" *ngIf="serviceResponseArrayModel.ServiceLists">
    <span *ngIf="serviceResponseArrayModel.ServiceLists.length">
      <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex" (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
      </mat-paginator>
    </span>
  </div>
</div>
<!---//Restaurant Manage Page-->